import React from 'react';
import './Activity.css'

const Activity = ({ activity, addTime }) => {
    const { index, id, img, name, timeRequirement } = activity;
    return (
        <div>
            <div className="card w-[95%] bg-base-100 shadow-xl">
                <figure><img src={img} className="w-[100%] h-[200px]" alt="Shoes" /></figure>
                <div className="card-body">
                    <h2 className="card-title text-2xl">{name} </h2>
                    <p>Time Need: <span>{timeRequirement}</span> min </p>
                    <div className="card-actions justify-center">
                        <button className="btn btn-outline btn-primary " onClick={() => addTime(timeRequirement)}>Add to List</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Activity;